import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FiltrarProjeto } from '../models/project-filter.model';
import { Observable } from 'rxjs';
import { ProjectsDto } from '../models/project-response.dto';
import { EstoqueProjeto } from '../models/project.model';

@Injectable({
  providedIn: 'root'
})
export class ProjetoFeiraService {
  private _apiUrl = environment.apiUrl + "/v1/Projetos";

  constructor(private http: HttpClient) { }

  consultarProjetosEmAndamento(filtro: FiltrarProjeto): Observable<ProjectsDto> {
    let params = new HttpParams();
    Object.entries(filtro).forEach(([key, value]) => {
      // Permitir valor 0 (status IniciadoProjeto) e strings não vazias
      if (value !== null && value !== undefined && value !== '') {
        params = params.append(key, value.toString());
      }
    });

    return this.http.get<ProjectsDto>(`${this._apiUrl}/todos`, { params })
  }

  consultarProjetosRealizados(filtro: FiltrarProjeto): Observable<ProjectsDto> {
    let params = new HttpParams();
    Object.entries(filtro).forEach(([key, value]) => {
      if (value) {
        params = params.append(key, value.toString());
      }
    });

    return this.http.get<ProjectsDto>(`${this._apiUrl}/realizados`, { params })
  }

  consultarTodosProjetos(filtro: FiltrarProjeto): Observable<ProjectsDto> {
    let params = new HttpParams();
    Object.entries(filtro).forEach(([key, value]) => {
      if (value) {
        // Transform to match API expected format (PascalCase)
        const transformedKey = key.charAt(0).toUpperCase() + key.slice(1);
        params = params.append(transformedKey, value.toString());
      }
    });

    return this.http.get<ProjectsDto>(`${this._apiUrl}/todos`, { params })
  }

  consultarEstoqueProjeto(filtro: FiltrarProjeto): Observable<ProjectsDto> {
    let params = new HttpParams();
    Object.entries(filtro).forEach(([key, value]) => {
      // Permitir valor 0 (status IniciadoProjeto) e strings não vazias
      if (value !== null && value !== undefined && value !== '') {
        params = params.append(key, value.toString());
      }
    });

    return this.http.get<ProjectsDto>(`${this._apiUrl}/estoque-projeto`, { params })
  }

  consultarEstoquesPorProjeto(projetoFeirtaId: string): Observable<{ estoquesProjeto: EstoqueProjeto[] }> {
    return this.http.get<{ estoquesProjeto: EstoqueProjeto[] }>(`${environment.apiUrl}/v1/EstoquesProjeto/Projeto/${projetoFeirtaId}`);
  }
}
